import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import { LEGAL_DOCS } from "@/lib/legalDocs";

export default function LegalDocPage() {
  const { docKey } = useParams();
  const navigate = useNavigate();
  const doc = LEGAL_DOCS[docKey];

  if (!doc) {
    return (
      <div style={{ minHeight: "100vh", background: "#030910", display: "flex",
        alignItems: "center", justifyContent: "center", padding: "40px 24px" }}>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: "rgba(255,255,255,0.5)", marginBottom: "16px" }}>
            That legal document doesn't exist.
          </p>
          <Link to="/" style={{ color: "#10B981", fontWeight: 600 }}>Back to home</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#030910", fontFamily: "'Inter', system-ui, sans-serif" }}>
      <div style={{ maxWidth: "680px", margin: "0 auto", padding: "48px 24px 80px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "48px" }}>
          <Link to="/"><Logo variant="dark" size="sm" /></Link>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: "inline-flex", alignItems: "center", gap: "6px",
              background: "none", border: "none", cursor: "pointer",
              color: "rgba(255,255,255,0.5)", fontSize: "13px", fontWeight: 600,
            }}
          >
            <ArrowLeft size={14} strokeWidth={2.2} /> Back
          </button>
        </div>

        <p style={{
          fontSize: "10px", fontWeight: 700, letterSpacing: "0.18em",
          textTransform: "uppercase", color: "rgba(16,185,129,0.85)", marginBottom: "8px",
        }}>
          Legal
        </p>
        <h1 style={{
          fontSize: "clamp(28px, 5vw, 38px)", fontWeight: 900,
          fontFamily: "'Fraunces', Georgia, serif", color: "#ffffff",
          marginBottom: "8px", lineHeight: 1.15,
        }}>
          {doc.title}
        </h1>
        <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.30)", marginBottom: "40px" }}>
          Last updated: {doc.updated} · Mikkshebs System Technology S.R.L.
        </p>

        {docKey === "delete-account" && (
          <div style={{
            background: "rgba(16,185,129,0.08)", border: "1px solid rgba(16,185,129,0.20)",
            borderRadius: "16px", padding: "18px 20px", marginBottom: "36px",
          }}>
            <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "13px", lineHeight: 1.6, margin: 0 }}>
              Already have an account? Go to{" "}
              <Link to="/login" style={{ color: "#10B981", fontWeight: 700 }}>Sign in</Link>
              {" "}→ Settings → Delete Account to delete it yourself right now.
            </p>
          </div>
        )}

        {doc.sections.map((s) => (
          <div key={s.heading} style={{ marginBottom: "28px" }}>
            <h2 style={{
              color: "rgba(255,255,255,0.90)", fontWeight: 700, fontSize: "16px",
              marginBottom: "8px",
            }}>
              {s.heading}
            </h2>
            <p style={{ color: "rgba(255,255,255,0.52)", fontSize: "14px", lineHeight: 1.75 }}>
              {s.body}
            </p>
          </div>
        ))}

        <p style={{
          fontSize: "12px", color: "rgba(255,255,255,0.24)", marginTop: "24px",
          paddingTop: "24px", borderTop: "1px solid rgba(255,255,255,0.07)",
        }}>
          Questions? Contact us at legal@moneymeetpay.com
        </p>
      </div>
    </div>
  );
}
